import { FC, useCallback } from 'react';
import { useSelector, useDispatch } from '@cbridge-utils/react-redux';
import { useIsReadOnly } from '@cbridge-packages/auth';
import { GridActionSwitch } from '@cbridge-tools/default-data-grid';
import { isAlertCellProcessingSelector } from '../../_selectors/isAlertCellProcessing.selector';
import { AlertSubscriptionAction } from '../../alertSubscription.action';
import { IAlertEmailSubscriptionCellProps } from './AlertEmailSubscriptionCell.interface';

export const AlertEmailSubscriptionCell: FC<IAlertEmailSubscriptionCellProps> = ({ email, alertType, checked }) => {
  const dispatch = useDispatch();
  const isReadOnly = useIsReadOnly();
  const isProcessing = useSelector(isAlertCellProcessingSelector, { cellKey: `${email}_${alertType}` });

  const handleToggle = useCallback(
    (enabled: boolean) => {
      dispatch(AlertSubscriptionAction.addEmailToSubscription.started({ email, type: alertType, enabled }));
    },
    [dispatch, email, alertType],
  );

  return (
    <GridActionSwitch
      checked={checked}
      disabled={isReadOnly || isProcessing}
      loading={isProcessing}
      onChange={handleToggle}
    />
  );
};
